import React, { Component } from "react";
import DocumentTitle from "react-document-title";
import "./index.css";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import BsySLoading from "../../BsySLoading";
import BsyMaskLayer from "../../BsyMaskLayer";
import { setPageTitle } from "../../../utils/setPageTitle";

class BsyDashboardInstallApp extends Component {
  state = {
    appId: "",
    appName: "",
    appDesc: "",
    image: "",
    phone: "",
    email: "",
    wechat: "",
    isNewapply: false,
  };
  componentDidMount() {
    let pathname = window.location.pathname.split("/");
    let id = pathname[pathname.length - 1];
    this.loadDetails(id);
  }
  loadDetails(id) {
    React.axios("/team/appinstall/" + id).then((res) => {
      console.log(res, id.length);
      if (id.length >= 24) {
        this.setState({
          isNewapply: true,
          appId: id,
          image: res.data.data.icon_url,
          appName: res.data.data.title,
          appDesc: res.data.data.desc,
          ver_info: res.data.data.ver_info,
        });
      } else {
        this.setState({
          isNewapply: false,
          appId: id,
          appName: res.data.data.title,
          image: res.data.data.image,
          appDesc: res.data.data.desc,
          phone: res.data.data.mobile,
          email: res.data.data.email,
          qq: res.data.data.qq,
          qq_url: res.data.data.qq_url,
          wechat: res.data.data.wechat,
        });
      }
    });
  }
  _installApp = (data, cb) => {

    let layerRef = null;
    BsyMaskLayer({
      customCls: "hasBackground",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />
          </div>
        );
      },
    });
    React.axios("/bbymember/tpl_install", {
      ...data,
    })
      .then((res) => {
        layerRef && layerRef.close();
        if (res.data.code === 200) {
          if (document.body.offsetWidth <= 1200) {
            window.FX.Utils.redirectTo("/team/app/" + res.data.data.strappid);
          } else {
            window.FX.Utils.redirectTo("/team/app/" + res.data.data.strappid);
          }
        } else {
          tipAlert({
            type: "warning",
            msg: res.data.msg,
          });
        }
        cb && cb();
      })
      .catch((res) => {
        layerRef && layerRef.close();
        if (res.state == 400) {
          tipAlert({
            type: "error",
            msg: res.data.msg,
          });
        }
      });
  };
  installApp = (id) => {
    return (event) => {
      event.stopPropagation();
      const _this = this;
      const n = window.$('<div class="app-ref-copy-content">');
      React.axios("/dashboard/app_group/list")
        .then((res) => {
          let a = new window.FX.AppInstallGroup({
            renderEl: n,
            groups: res.data.items,
          });
          let copyDialog;
          let importdata = true;
          copyDialog = new window.FX.ConfirmDialog({
            title: React.language("template.install.toGroup"),
            width: document.body.offsetWidth <= 1200 ? 370 : 450,
            height: 390,
            onContentCreate: function (e) {
              e.append(n);
              new window.FX.CheckBox({
                renderEl: window
                  .$('<div style="margin-left: 20px;margin-top: 10px;" />')
                  .appendTo(e),
                value: importdata,
                onStateChange: function (ed) {
                  importdata = ed;
                },
                text: React.language("import.package.group.tip"),
              });
            },
            onOk: function () {
              var toappid = a.getValue();
              console.log(_this.state.isNewapply)
              if (_this.state.isNewapply) {
                _this._installApp({
                  mode: "scheme",
                  tpl_id: id,
                  groupid: toappid.groupId,
                  sampledata: importdata,
                });
              } else {
                _this._installApp({
                  mode: "tpl",
                  tpl_id: id,
                  groupid: toappid.groupId,
                  sampledata: importdata,
                });
              }

              copyDialog.close();
            },
          });
          copyDialog.show();
        })
        .catch((res) => { });
    };
  };
  cancelInstall = () => {
    window.location.href = window.rootDirectroy + "/";
  };
  render() {
    const { appId, appName, appDesc, phone, email, wechat, image, qq, qq_url } =
      this.state;
    setPageTitle(React.language("template.install"));
    return (

      <div className="BsyDashboardInstallApp">
        <div className="install-header">
          {/* {React.language("install.app.title", { appName: appName })} */}
        </div>
        <div className="app-details">
          <div className="detail-left">
            <div className="img-header">{appName}</div>
            <img src={image} alt={appName} />
          </div>
          <div className="detail-right">
            <div className="app-name" title={appName}>
              {appName}
            </div>
            <div className="app-desc" title={appDesc}>
              {appDesc}
            </div>
            {/* <div className="app-tip">
                <i className="icon-bsy-install-zhizao"></i>
                <span>{React.language("install.app.tip")}</span>
              </div> */}
          </div>
        </div>
        <div className="app-connect">
          {!this.state.isNewapply && (
            <div>
              <div className="connect-title">
                {React.language("Contact.information") + "："}
              </div>
              <div className="connect-content">
                {(phone || email || (qq && qq_url)) && (
                  <div className="email-phone-qq">
                    {phone && (
                      <div className="phone connect">
                        <i className="icon-bsy-install-phone"></i>
                        <span>{phone}</span>
                      </div>
                    )}
                    {email && (
                      <div className="email connect">
                        <i className="icon-bsy-install-email"></i>
                        <span>{email}</span>
                      </div>
                    )}
                    {qq && qq_url && (
                      <div className="qq connect">
                        <div className="qq-content">
                          <i className="icon-bsy-install-qq"></i>
                        </div>
                        <div className="qq-a">
                          <a href={qq_url} target="_blank">
                            {qq}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {wechat && (
                  <div className="wechat">
                    <div className="wechat-img">
                      <img
                        src={wechat}
                        alt={React.language("install.app.wechat.title")}
                      />
                    </div>
                    <div className="wechat-content">
                      <i className="icon-bsy-install-wechat"></i>
                      <span>
                        {React.language("install.app.wechat.title")}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {this.state.isNewapply && (
            <div className={"edition"}>
              <div>
                <div className={"left"}>开发者</div>
                <div className={"right"}>{this.state.ver_info.author}</div>
              </div>
              <div>
                <div className={"left"}>版本</div>
                <div className={"right"}>{this.state.ver_info.version}</div>
              </div>
              <div>
                <div className={"left"}>最后更新时间</div>
                <div className={"right"}>
                  {this.state.ver_info.update_time}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="app-footer">
          <div className="app-btn">
            <div className="app-install" onClick={this.installApp(appId)}>
              {React.language("install.app.ok")}
            </div>
            <div className="app-cancel-install" onClick={this.cancelInstall}>
              {React.language("install.app.cancel")}
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default BsyDashboardInstallApp;
